exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card{border:0;border-radius:0;font-size:16px}.decorative{background-color:#e6e6e6;padding:20px 39px;font-size:14px}\n", ""]);

// exports
